import { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom"

export const isInButtonOrLink = element => {
    const elements = [element]
    while (elements[elements.length - 1].parentNode) elements.push(elements[elements.length - 1].parentNode)
    return elements.some(x => ['A', 'BUTTON'].includes(x.tagName))
}

export function Menu({ children, activator, ...props }) {
    const [open, setOpen] = useState()
    const [top, setTop] = useState(0)
    const [bottom, setBottom] = useState()
    const [right, setRight] = useState(0)
    const activatorRef = useRef()
    const menuRef = useRef()

    useEffect(() => {
        const closeOnOutsideOrButtonClick = e => {
            if (open && !activatorRef.current.contains(e.target) && (!menuRef.current.contains(e.target) || isInButtonOrLink(e.target))) setOpen(false)
        }
        window.addEventListener('click', closeOnOutsideOrButtonClick)
        return () => window.removeEventListener('click', closeOnOutsideOrButtonClick)
    })

    useEffect(() => {
        const setPosition = () => {
            if (!activatorRef.current || !open) return
            const { top, height, left, width } = activatorRef.current.getBoundingClientRect()
            if (window.innerHeight - top - height < 300) {
                setTop(undefined)
                setBottom(window.innerHeight - top)
            } else {
                setTop(top + height)
                setBottom(undefined)
            }
            setRight(window.innerWidth - left - width)
        }
        setPosition()
        window.addEventListener('scroll', setPosition)
        return () => window.removeEventListener('scroll', setPosition)
    })

    return <div {...props}>
        <div ref={activatorRef} onClick={() => setOpen(!open)} className="cursor-pointer h-full">
            {activator}
        </div>
        {open && <div className="fixed z-30" style={{ top, bottom, right }}>
            <div ref={menuRef} className="my-2 rounded-lg bg-white drop-shadow-lg max-h-[500px] overflow-auto">
                {children}
            </div>
        </div>}
    </div>
}

export function MenuLink({ children, to, href, icon, ...props }) {
    const Component = to ? Link : href ? 'a' : 'button'

    return <Component {...props} to={to} href={href} className={`px-4 py-3 w-full flex items-center gap-3 hover:bg-gray-200 [&:not(:first-child)]:border-t border-gray-300 first:rounded-t-lg last:rounded-b-lg ${props.className}`}>
        {icon}
        <div className="whitespace-nowrap">{children}</div>
    </Component>
}